import {IRecurso} from "@models/recurso/IRecurso.ts";
import {Button, Grid, TextField} from "@mui/material";
import {useEffect, useState} from "react";
import {useRecurso} from "@components/recurso/hooks/useRecurso.ts";
import {fullHeight} from "@models/helpers.ts";

interface RenameRecursoComponentProps {
    recurso?: IRecurso | number;
    onUpdate?: (v: IRecurso) => void
}

export function RenameRecursoComponent(props: RenameRecursoComponentProps) {
    const {getRecurso, updateRecurso} = useRecurso()
    const [currentRecurso, setCurrentRecurso] = useState<IRecurso | undefined>(undefined)
    const [original, setOriginal] = useState<IRecurso | undefined>(undefined)
    const {recurso} = props;

    useEffect(() => {
        if (typeof recurso === 'number') {
            getRecurso(recurso).then(x => {
                if (x.items.length > 0) {
                    setOriginal(x.items[0])
                }
            })
        } else {
            setOriginal(recurso)
        }
    }, []);

    useEffect(() => {
        if (original != null)
            setCurrentRecurso(original)
    }, [original]);

    return (currentRecurso &&
        <Grid container>
            <Grid size={"grow"}>
                <TextField label={'Nome'} onChange={(e) => {
                    if (currentRecurso != null)
                        setCurrentRecurso({...currentRecurso, nome: e.target.value})
                }} value={currentRecurso?.nome}/>
            </Grid>
            <Grid>
                <Button sx={{...fullHeight}} onClick={() => updateRecurso(currentRecurso).then((x) => {
                    if (props.onUpdate != null)
                        props.onUpdate(x)
                })} fullWidth>Renomear</Button>
            </Grid>
        </Grid>
    )
}